import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { initiatePayment } from "../../utils/backend";

import BottomMessagePopUp from "../../components/BottomMessagePopUp";

const MakePayment = () => {
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const showErrorMessage = (msg) => {
        setErrorMessage(msg);
        setIsErrorVisible(true);
    };
    const token = searchParams.get("token");
    const orderNumber = searchParams.get("orderNumber");

    useEffect(() => {
        const processPayment = async () => {
            if (!token || !orderNumber) {
                showErrorMessage("Missing token or order number.");
                return;
            }

            try {
                const paymentResponse = await initiatePayment(token, orderNumber);

                if (paymentResponse) {
                    // Create a container to hold the HTML content
                    const container = document.createElement("div");
                    container.innerHTML = paymentResponse;

                    // Append the container to the document body
                    document.body.appendChild(container);

                    // Find the form and submit it
                    const form = container.querySelector("#ipay88Form");
                    if (form) {
                        form.submit();
                    } else {
                        showErrorMessage("Payment form is unavailable.");
                    }
                } else {
                    showErrorMessage("Failed to retrieve payment script.");
                }
            } catch (error) {
                // console.error("Error during payment initialization:", error);
                showErrorMessage(error.response.data.message)
            }
        };

        processPayment();
    }, [token, orderNumber]);

    return (
        <div>
            {errorMessage ? (
                <p style={{ color: "red" }}>{errorMessage}</p>
            ) : (
                <p>Processing your payment...</p>
            )}
            {/* BottomMessagePopUp Component */}
            <BottomMessagePopUp
                message={errorMessage}
                type="error"
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
        </div>
    );
};

export default MakePayment;
